import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import moment from "moment";
import {
	setAlertMessageSnackbarMessageSeverity,
	setAlertMessageSnackbarMsg,
	setAlertMessageSnackbarOpen,
} from "../store/feedback";

import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import "./camera.css";
import axios from "axios";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";

import carImage from "./new-img.png";

import { Modal } from 'antd';
import FileContext from "../context/Context";
import { SnackbarAlert } from "../custom-component/AlertMessage";
import InspectionSteps from "./InspectionSteps";
import { Box, Typography } from "@mui/material";
import ImageProgressBar from "./ImageProgressBar";
import CustomToastify from "./custom-notified-msg/CustomToastify";
import { set_image_upload_status } from "../store/image_upload";
import { useFullscreen } from "../context/FullScreenContext";
import CustomVideoToastify from "./custom-notified-msg/CustomVideoToastify";
import VideoTimer from "../video-module/video-timer/VideoTimer";
import Photo_Video_Instruction from "./photo_video_instruction/Photo_Video_Instruction";

const CameraModuleHybrid = () => {
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [videoCaptured, setVideoCaptured] = useState(false);
	const { requestFullscreen, isFullscreen } = useFullscreen();
	const [showInstructionPage,setShowInstructionPage]=useState(false);
	const [dialogWidth, setDialogWidth] = useState("29vw");
	const [dialogText, setDialogText] = useState("0.9rem");
	const [btnType, setBtnType] = useState(true);
	const timerRef = useRef(31); // Ref to store elapsed time
	const intervalRef = useRef(null);
	const isIOS = () => {
		return (
			/iPhone|iPad|iPod/i.test(navigator.userAgent) ||
			(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
		);
	};

	const cameraContainerRef = useRef(null);
	const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`;
	const reload = `${process.env.PUBLIC_URL}/custom-icons/reload.png`;
	const cameraOption = `${process.env.PUBLIC_URL}/inspection-images/camera-option.png`;

	const car_front_side = `${process.env.PUBLIC_URL}/stencils-img/car-front-side.png`;
	const car_front_left_side = `${process.env.PUBLIC_URL}/stencils-img/car-front-left-side.png`;
	const car_front_right_side = `${process.env.PUBLIC_URL}/stencils-img/car-front-right-side.png`;
	const car_back_side = `${process.env.PUBLIC_URL}/stencils-img/car-back-side.png`;
	const car_back_left_side = `${process.env.PUBLIC_URL}/stencils-img/car-back-left-side.png`;
	const car_back_right_side = `${process.env.PUBLIC_URL}/stencils-img/car-back-right-side.png`;
	const car_left_side = `${process.env.PUBLIC_URL}/stencils-img/car-left-side.png`;
	const car_right_side = `${process.env.PUBLIC_URL}/stencils-img/car-right-side.png`;
	const car_tyre = `${process.env.PUBLIC_URL}/stencils-img/tyre.png`;
	const car_RC = `${process.env.PUBLIC_URL}/stencils-img/RC.png`;
	const car_chassis = `${process.env.PUBLIC_URL}/stencils-img/chassis.png`;
	const car_odometer = `${process.env.PUBLIC_URL}/stencils-img/odometer.png`;
	const car_outer_windshield = `${process.env.PUBLIC_URL}/stencils-img/car-outer-windshield.png`;
	const car_inner_windshield = `${process.env.PUBLIC_URL}/stencils-img/car-inner-windshield.png`;

	const camera = useRef(null);
	const {

		setCapturedImages360,
		setCapturedImageWindshield,
		setCapturedChassisRC,
		setCapturedRegNo,
		setCapturedOdometer,
		setCapturedTyres,
		capturedInspectionImages,
		setCapturedInspectionImages,
		setCarView,
		carView,
		odometerVideo,
		setOdometerVideo
	} = useContext(FileContext);

	const [capturedTime, setCapturedTime] = useState(null);
	const [hasRetaken, setHasRetaken] = useState(false);


	const { auditID, latitude, longitude } = useSelector(
		(state) => state.imagesStore
	);

	const [isModalVisible, setIsModalVisible] = useState(false);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		console.log("juu")
		setIsModalVisible(false);
	};
	const openCameraOption = () => {

		showModal(); // Trigger the modal when the photo is captured
		console.log("camera options");

	};
	console.log(isFullscreen)
	//   useEffect(()=>{
	// 	if(!isFullscreen){
	// 		requestFullscreen()
	// 	}

	//   },[isFullscreen])
	// useEffect(() => {
	//     let timer;
	//     if (videoCaptured) {
	//       timer = setTimeout(() => {
	//         navigate(`/processing/video/${audit_id}`);
	//       }, 6000);
	//     }

	//     // Cleanup function to clear the timeout if the component unmounts or videoCaptured changes
	//     return () => clearTimeout(timer);
	//   }, [videoCaptured, navigate]);
	//   const webcamRef = useRef(null);
	const mediaRecorderRef = useRef(null);
	const [capturing, setCapturing] = useState(false);
	const [recordedChunks, setRecordedChunks] = useState([]);

	const videoConstraintsForVideo = {
		facingMode: "environment",
		width: { ideal: 1920 }, // Lower resolution for mobile
		height: { ideal: 1080 },
		frameRate: { ideal: 30, max: 60 }, // Cap at 30fps for mobile
		audio: true
	};
	const recordedChunksRef = useRef([]);


	console.log("timer", timerRef.current)
	const handleRetakeForVideo = () => {
		setVideoCaptured(false);
		setRecordedChunks([]);
		mediaRecorderRef.current = null; // Reset the MediaRecorder

		// Check if webcamRef and video element are defined
		if (webcamRef.current && webcamRef.current.video) {
			const videoElement = webcamRef.current.video;
			if (videoElement.srcObject) {
				videoElement.srcObject.getTracks().forEach(track => track.stop()); // Stop the previous webcam stream
			}
		} else {
			console.error("Webcam ref or video element is null.");
		}

		// Reinitialize the webcam (or let React do this automatically if using `Webcam` component properly)
		setTimeout(() => {
			if (currentImageTitle.id === 12) {
				setOdometerVideo(null)
			}
			else if (currentImageTitle.id === 21) {
				setCarView(null)
			}

		}, 1000); // Delay to ensure cleanup is done
	};

	useEffect(() => {
		if (timerRef.current <= 0) {
			handleStopCaptureClick(); // Stop capture when timer hits 0
		}
	}, [capturing]);  // Listen for changes in capturing state

	const handleStopCaptureClick = useCallback(async () => {
		setBtnType(!btnType);
		setVideoCaptured(!videoCaptured);
		console.log("stop");

		mediaRecorderRef.current.stop();
		setCapturing(false);
		clearInterval(intervalRef.current);
		if(currentImageTitle.viewName === "RPM Meter Video")
		timerRef.current = 31;
	    else
		timerRef.current = 61;
		console.log(recordedChunks, "183")

	}, [btnType])
	console.log("videoCaptured", videoCaptured)
	useEffect(() => {
		const handleResize = () => {

			if (window.innerWidth <= 400) {
				setDialogWidth("85vw");


			} else if (window.innerWidth <= 475) {
				setDialogWidth("74vw");
			} else if (window.innerWidth <= 550) {

			} else if (window.innerWidth <= 575) {
				setDialogText("0.6rem");
				setDialogWidth("64vw");
			} else if (window.innerWidth <= 650) {
				setDialogWidth("60vw");
			} else if (window.innerWidth <= 775) {
				setDialogWidth("57vw");
			} else if (window.innerWidth <= 875) {
				setDialogWidth("55vw");
			} else if (window.innerWidth <= 1000) {
				setDialogWidth("48vw");
			} else if (window.innerWidth <= 1100) {
				setDialogWidth("45vw");
				setDialogText("0.8rem");
			} else if (window.innerWidth <= 1300) {
				setDialogWidth("40vw");
			} else {
				setDialogWidth("35vw");
			}
		};

		handleResize();

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	
	const imagesToCaptureInHybrid = [
		{
			viewName: "Front Side",
			imageName: "front_side",
			imageStencils: car_front_side,
			mode: "photo",
			id: 1,
		},
		{
			viewName: "Front Left Side",
			imageName: "front_left_side",
			imageStencils: car_front_left_side,
			mode: "photo",
			id: 2,
		},
		{
			viewName: "Left Side",
			imageName: "left_side",
			imageStencils: car_left_side,
			mode: "photo",
			id: 3,
		},
		{
			viewName: "Back Left Side",
			imageName: "back_left_side",
			imageStencils: car_back_left_side,
			mode: "photo",
			id: 4,
		},
		{
			viewName: "Back Side",
			imageName: "back_side",
			imageStencils: car_back_side,
			mode: "photo",
			id: 5,
		},
		{
			viewName: "Back Right Side",
			imageName: "back_right_side",
			imageStencils: car_back_right_side,
			mode: "photo",
			id: 6,
		},
		{
			viewName: "Right Side",
			imageName: "right_side",
			imageStencils: car_right_side,
			mode: "photo",
			id: 7,
		},
		{
			viewName: "Front Right Side",
			imageName: "front_right_side",
			imageStencils: car_front_right_side,
			mode: "photo",
			id: 8,
		},

		{
			viewName: "Outer Windshield",
			imageName: "outer_windshield",
			imageStencils: car_outer_windshield,
			mode: "photo",
			id: 9,
		},
		{
			viewName: "Inner Windshield",
			imageName: "inner_windshield",
			imageStencils: car_inner_windshield,
			mode: "photo",
			id: 10,
		},
		{
			viewName: "Odometer",
			imageName: "odometer",
			imageStencils: car_odometer,
			mode: "photo",
			id: 11,
		},
		{
			viewName: "RPM Meter Video",
			imageName: "rpm_meter_video",
			// imageStencils:car_odometer,
			mode: "video",
			id: 12,
		},	
		{
			viewName: "Registration Number",
			imageName: "registrationNo",
			imageStencils: car_RC,
			mode: "photo",
			id: 13,
		},
		{
			viewName: "Chassis Number",
			imageName: "chassis",
			imageStencils: car_chassis,
			mode: "photo",
			id: 14,
		},
		{
			viewName: "RC",
			imageName: "RC",
			imageStencils: car_RC,
			mode: "photo",
			id: 15,
		},
		{
			viewName: "Front Left Tyre",
			imageName: "front_left_tyre",
			imageStencils: car_tyre,
			mode: "photo",
			id: 16,
		},
		{
			viewName: "Back Left Tyre",
			imageName: "back_left_tyre",
			imageStencils: car_tyre,
			mode: "photo",
			id: 17,
		},
		{
			viewName: "Back Right Tyre",
			imageName: "back_right_tyre",
			imageStencils: car_tyre,
			mode: "photo",
			id: 18,
		}, {
			viewName: "Front Right Tyre",
			imageName: "front_right_tyre",
			imageStencils: car_tyre,
			mode: "photo",
			id: 19,
		},
		{
			viewName: "Selfie",
			imageName: "selfie",
			// imageStencils: "",
			mode: "photo",
			id: 20,
		},
		{
			viewName: "360° View",
			imageName: "360_view",
			// imageStencils:car_odometer,
			mode: "video",
			id: 21,
		},
	]
		
	
	const [image, setImage] = useState(null);
	const webcamRef = useRef(null);
	const [showImage, setShowImage] = useState(false);
	const [imageCaptured, setImageCaptured] = useState(false);
	const [showCamera, setShowCamera] = useState(false);
	const [numberOfCameras, setNumberOfCameras] = useState(0);
	const [activeDeviceId, setActiveDeviceId] = useState(undefined);
	const [devices, setDevices] = useState([]);
	const [imageBuffer, setImageBuffer] = useState(null)
	const [currentImageIndex, setCurrentImageIndex] = useState(
		0
	);

	const [imageDimensions, setImageDimensions] = useState({
		width: 0,
		height: 0,
	});
	const containerRef = useRef(null);
	const navigate = useNavigate();
	const [isInLandscapeMode, setIsInLandscapeMode] = useState(
		window.screen.orientation.type
	);

	const [suggestion, setSuggestion] = useState('');
	const [perfectImage, setPerfectImage] = useState(false);

	const analyzeLighting = (imageData) => {
		//console.log(imageData, "9")
		const { data, width, height } = imageData;
		let totalBrightness = 0;

		for (let i = 0; i < data.length; i += 4) {
			const r = data[i];
			const g = data[i + 1];
			const b = data[i + 2];
			const brightness = (r + g + b) / 3;
			totalBrightness += brightness;
		}

		const averageBrightness = totalBrightness / (width * height);

		if (averageBrightness < 100) {
			return 'Increase lighting.';
		} else if (averageBrightness > 200) {
			return 'Reduce lighting.';
		} else {
			return 'Lighting looks good.';
		}
	};

	const captureAndAnalyze = useCallback(() => {

		if (webcamRef?.current && webcamRef.current?.getScreenshot()) {
			const imageSrc = webcamRef.current.getScreenshot();
			const image = new Image();
			image.src = imageSrc;

			image.onload = () => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				canvas.width = image.width;
				canvas.height = image.height;
				ctx.drawImage(image, 0, 0, image.width, image.height);

				const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
				const lightingSuggestion = analyzeLighting(imageData);
				if (lightingSuggestion === "Lighting looks good.") {
					setPerfectImage(true)
				}
				else {
					setPerfectImage(false)
				}
				setSuggestion(lightingSuggestion);
			};
		}
	}, []);

	console.log(suggestion, "245")
	useEffect(() => {
		if (isInLandscapeMode !== "portrait-primary" && isInLandscapeMode !== "portrait-secondary") {
			const interval = setInterval(captureAndAnalyze, 500); // Analyze every 500ms
			return () => clearInterval(interval);
		}

	}, [captureAndAnalyze, isInLandscapeMode]);
	const [currentImageTitle, setCurrentImageTitle] = useState(
		imagesToCaptureInHybrid[0]
	);
	const [changed,setChanged]=useState("abc");

	const handleDataAvailable = useCallback(({ data }) => {
		console.log("Data available:", data);
		if (data.size > 0) {
			
			recordedChunksRef.current.push(data); // Store in the ref
			setRecordedChunks(prev => [...prev, data]); // Update state
			console.log("Recorded chunks updated:", recordedChunksRef.current);
			if (currentImageTitle.id === 12) {
				setOdometerVideo(recordedChunksRef.current)
			}
			else if (currentImageTitle.id === 21) {
				setCarView(recordedChunksRef.current)
			}
			let res = {
				file: recordedChunksRef.current,
				name: currentImageTitle.imageName,
				clickedTime: capturedTime,
				id: currentImageTitle.id,
				latitude: latitude,
				longitude: longitude,
			};
			setCapturedInspectionImages((prevImages) => {
				// Filter out any images with the same id as the new one
				const filteredImages = prevImages.filter(image => image.id !== res.id);

				// Add the new image
				return [...filteredImages, res];
			});
			
		}
	}, [currentImageTitle]);

	const azure_image_file_name = (audit_id, image_name, file_name) => {
		return `${audit_id}_${image_name}_${file_name}`
	}
	const upload_image_to_azure = async (auditID, id, clicked_time, latitude, longitude, fileName, imageBuffer, image_name) => {
		console.log(imageBuffer, "296")

		axios.post("/aiProcessingApis/uploadToTopic", { "id": id, "auditID": auditID, "image_name": fileName, "imageCategory": image_name, "clicked_time": clicked_time, "latitude": latitude, "longitude": longitude });

		const headers = {
			'Content-Type': 'image/jpeg',
			'x-ms-blob-type': 'BlockBlob'
		};

		const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

		axios.put(url, imageBuffer, { headers })
			.then(response => {
				if (response.status === 201) {
					const res = {
						image_name: image_name,
						status: 1,
						type: "azure_img_upload_status"
					}
					dispatch(set_image_upload_status(res))
				}
				console.log('File uploaded successfully status Code : ', response.status);
			})
			.catch(error => {
				console.error('Error uploading file:', error);
			});
	}

	const cacheImageBuffer = async (fileName, imageBuffer, clicked_time, name, type, audit_id, latitude, longitude) => {
		try {
			// Open or create the 'image-cache' cache
			const cache = await caches.open('image-cache');

			// Convert the image buffer to a Blob
			const imageBlob = new Blob([imageBuffer], { type: 'image/png' });

			// Prepare the metadata in JSON format
			const metadata = JSON.stringify({
				clicked_time,
				name,
				type,
				audit_id,
				latitude,
				longitude
			});

			// Create a Response object for the image
			const cachedImageResponse = new Response(imageBlob, {
				headers: { 'Content-Type': 'image/png' }
			});

			// Create a Response object for the metadata
			const cachedMetadataResponse = new Response(metadata, {
				headers: { 'Content-Type': 'application/json' }
			});

			// Cache the image with the fileName as the key
			await cache.put(`${fileName}`, cachedImageResponse);

			// Cache the metadata with a related key
			await cache.put(`${fileName}-metadata`, cachedMetadataResponse);

			console.log(`Image and metadata cached successfully with key: ${fileName}`);
		} catch (error) {
			console.error('Failed to cache image and metadata:', error);
		}
	};

	const handleFullscreenRequest = () => {
		requestFullscreen();
		setOpen(false);
	}
	const handleClose = (event) => {
		if (
			event.target.tagName.toLowerCase() !== "button" &&
			!event.target.closest("button")
		) {
			// Prevent dialog from closing if click occurred outside of the button
			return;
		}
		setOpen(false);
	};
	const handleSave = () => {
		// setImageCaptured(false);
		// setShowCamera(false);
		console.log(imageBuffer, image, "381")
		if (!auditID) {
			let alert = {
				snackbarOpen: true,
				snackbarMessage: "Audit not found !",
				snackbarMessageSeverity: "error",
			};
			dispatch(
				setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
			);
			dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
			dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
			setTimeout(() => {
				dispatch(setAlertMessageSnackbarOpen(false));
			}, 5000);

			navigate("/");
		} else {

			const currentImage = imagesToCaptureInHybrid[currentImageIndex];
			const cur_img_id = currentImage.id >= 14 ? currentImage.id - 2 : currentImage.id;

			let res = {
				file: image,
				name: currentImage.imageName,
				clickedTime: capturedTime,
				id: currentImage.id,
				latitude: latitude,
				longitude: longitude,
			};
			let activeId;

			if (
				currentImage.imageName === "inner_windshield" ||
				currentImage.imageName === "outer_windshield"
			) {
				setCapturedImageWindshield((prevImages) => [...prevImages, res]);
				activeId = "1";
			} else if (currentImage.imageName === "registrationNo") {
				setCapturedRegNo((prevImages) => [...prevImages, res]);
				activeId = "1";
			} else if (
				currentImage.imageName === "chassis" ||
				currentImage.imageName === "RC"
			) {
				setCapturedChassisRC((prevImages) => [...prevImages, res]);
				activeId = "1";
			} else if (currentImage.imageName === "odometer") {
				setCapturedOdometer((prevImages) => [...prevImages, res]);
				activeId = "1";
			} else if (currentImage.imageName === "front_left_tyre" || currentImage.imageName === "back_left_tyre" || currentImage.imageName === "back_right_tyre" || currentImage.imageName === "front_right_tyre") {
				setCapturedTyres((prevImages) => [...prevImages, res]);
				activeId = "1";
			}
			else {
				setCapturedImages360((prevImages) => [...prevImages, res]);
				activeId = "0";
			}
			setCapturedInspectionImages((prevImages) => {
				// Filter out any images with the same id as the new one
				const filteredImages = prevImages.filter(image => image.id !== res.id);

				// Add the new image
				return [...filteredImages, res];
			});

			console.log(azure_image_file_name(auditID, res.name, res.file.name), "355")
			try {

				const fileName = azure_image_file_name(auditID, res.name, res.file.name);

				console.log(res.file, "378")
				const reader = new FileReader();
				let buffer_curr;
				reader.onloadend = () => {
					buffer_curr = reader.result;
					// setImageBuffer(buffer_curr)
					console.log(buffer_curr, "457"); // You can now use the buffer
					cacheImageBuffer(fileName, buffer_curr, res.clickedTime, res.name, res.id, auditID, latitude, longitude)
					upload_image_to_azure(auditID, res.id, res.clickedTime, latitude, longitude, fileName, buffer_curr, res.name);
					if (auditID) {
						const formData = new FormData();
						// formData.append("file", res.file);

						formData.append("clickedTime", res.clickedTime);
						formData.append("name", res.name);
						formData.append("id", res.id >= 13 ? res.id - 1 : res.id);
						formData.append("auditID", auditID);
						// formData.append("data", capturedImages360);
						formData.append("latitude", latitude);
						formData.append("longitude", longitude);
						formData.append("azure_image_name", azure_image_file_name(auditID, res.name, res.file.name));



						upload_images_data_db(formData, res.name);


					}
				};
				reader.readAsArrayBuffer(image);

			} catch (err) {
				console.log(err);
			}
		}
	};
	const upload_video_to_azure = async (fileName, videoBlob) => {
		const videoType = videoBlob.type || 'video/mp4';

		const headers = {
			'Content-Type': videoType,
			'x-ms-blob-type': 'BlockBlob',
		};

		const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditVideos/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

		await axios.put(url, videoBlob, {
			headers,
			onUploadProgress: (progressEvent) => {
				const total = progressEvent.total;
				const current = progressEvent.loaded;
				const percentCompleted = Math.round((current * 100) / total);
				// setUploadProgress(percentCompleted); // Update the progress state
				console.log(`Upload progress: ${percentCompleted}%`);
			}
		})
			.then(response => {
				if (response.status === 201) {
					console.log('Video uploaded successfully:', response.status);

				}
			})
			.catch(error => {
				console.error('Error uploading video:', error);
			});
	};
	useEffect(() => {
		if ((imageCaptured || videoCaptured) && !hasRetaken) {
			if (imageCaptured) {
				handleSave();  // Call handleSave immediately when imageCaptured is true
			}
			// if(videoCaptured){

			// 	if(currentImageTitle.id === 12){
			// 	const fileName = `${auditID}_odometer_video.mp4`;
			// 	upload_video_to_azure(fileName,odometerVideo[0])
			//    }
			//    else if(currentImageTitle.id === 13){
			// 	const fileName = `${auditID}_engine_video.mp4`;
			// 	 setEngineVideo(fileName,engineVideo[0])
			//    }


			// }





			const timer = setTimeout(() => {
				const currentImage = imagesToCaptureInHybrid[currentImageIndex];
				console.log(currentImageIndex < imagesToCaptureInHybrid.length - 1);
				console.log(currentImageIndex, imagesToCaptureInHybrid.length - 1);
				if (currentImageIndex < imagesToCaptureInHybrid.length - 1) {
					setCurrentImageIndex(currentImageIndex + 1);
					setCurrentImageTitle(imagesToCaptureInHybrid[currentImageIndex + 1]);
					console.log(imagesToCaptureInHybrid[currentImageIndex + 1].viewName, "371")
					if (imagesToCaptureInHybrid[currentImageIndex + 1].viewName === "Selfie") {

						videoConstraintsRef.current = {
							facingMode: "user", // switch to front camera
							width: 1920,
							height: 1080,
						};
					}
					else
					{
						videoConstraintsRef.current = {
							facingMode: "environment", // switch to front camera
							width: 1920,
							height: 1080,
						};
					}
					// setShowCamera(true);
				}
				setImageCaptured(false);  // Update states after 6 seconds
				
				if (videoCaptured) {
					setVideoCaptured(false);
				}
				if (currentImageIndex < imagesToCaptureInHybrid.length - 1) {
				setShowInstructionPage(
					imagesToCaptureInHybrid[currentImageIndex + 1].viewName === "RPM Meter Video"
				  );
				}
				setShowCamera(true);
				console.log("Updated states after 6 seconds");
			}, 6000);

			return () => clearTimeout(timer);  // Clean up the timer
		}
	}, [hasRetaken, imageCaptured, videoCaptured]);


	useEffect(() => {
		const handleBeforeUnload = (event) => {
			const message = "Are you sure you want to leave?";
			event.returnValue = message;
			return message;
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);


	useEffect(() => {
		if (!auditID) {
			console.log("audit not present");
			navigate("/");
		}
	}, [auditID]);

	useEffect(() => {
		if (capturedInspectionImages.length === 21) {
			const timer = setTimeout(() => {
				navigate(`/processing/hybrid/${auditID}`);
			}, 6000); // Pass 6000 directly

			return () => {
				clearTimeout(timer); // Clear timeout on cleanup
			};
		}
	}, [capturedInspectionImages, auditID, navigate]); // Add auditID and navigate as dependencies

	useEffect(() => {
		const handleBeforeUnload = (event) => {
			const message = "Are you sure you want to leave?";
			event.returnValue = message;
			return message;
		};

		const handlePopState = (event) => {
			// console.log("back button");
			if (window.confirm("Are you sure you want to navigate away?")) {
				navigate("/");
			}
		};

		const handleHashChange = (event) => {
			if (window.confirm("Are you sure you want to navigate away?")) {
			}
		};

		window.addEventListener("beforeunload", handleBeforeUnload);
		window.addEventListener("popstate", handlePopState);
		window.addEventListener("hashchange", handleHashChange);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
			window.removeEventListener("popstate", handlePopState);
			window.removeEventListener("hashchange", handleHashChange);
		};
	}, []);
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const setDimensions = () => {
		const img = new Image();
		img.src = currentImageTitle?.imageStencils;
		img.onload = () => {
			const containerWidth = window.innerWidth;
			const containerHeight = window.innerHeight;
			const containerAspectRatio = containerWidth / containerHeight;
			const imgAspectRatio = img.width / img.height;

			let width, height;

			if (imgAspectRatio > containerAspectRatio) {
				width = containerWidth;
				height = containerWidth / imgAspectRatio;
			} else {
				width = containerHeight * imgAspectRatio;
				height = containerHeight;
			}

			setImageDimensions({ width, height });
		};
	};
	useEffect(() => {
		setDimensions();
		window.addEventListener("resize", setDimensions);
		return () => {
			window.removeEventListener("resize", setDimensions);
		};
	}, [currentImageTitle?.imageStencils]);
	useEffect(() => {
		const handleResize = () => {
			setWindowDimensions({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);


	const handleRetakeClick = () => {
		setHasRetaken(true);
		handleRecapture();
	};

	const getDeviceType = () => {
		const os = window.platform.os;

		if (os.family === "iOS") {
			return "iPhone";
		} else if (os.family === "Android") {
			return "Android";
		} else {
			const isLaptop = window.innerWidth > 1024;
			return isLaptop ? "Laptop" : "Unknown Device";
		}
	};
	const deviceType = getDeviceType();
	let mutipier = 8;
	if (deviceType === "Android") {
		mutipier = 1;
	}

	const videoConstraintsRef = useRef({
		facingMode: "environment", // initial facing mode
		width: 1920,
		height: 1080,
	});
	console.log(videoConstraintsRef.current.facingMode, "video constraints")
	useEffect(() => {
		async function fetchDevices() {
			const devices = await navigator.mediaDevices.enumerateDevices();
			const videoDevices = devices.filter(
				(i) =>
					i.kind === "videoinput" &&
					(i.label.includes("back") || i.label.includes("rear"))
			);
			setDevices(videoDevices);
			if (videoDevices.length > 0) {
				if (videoDevices.length === 2) {
					setActiveDeviceId(videoDevices[1].deviceId);
				} else setActiveDeviceId(videoDevices[0].deviceId);
			}
		}

		fetchDevices();
	}, []);

	const handleCameraError = () => {
		let alert = {
			snackbarOpen: true,
			snackbarMessage: "camera permission not granted !",
			snackbarMessageSeverity: "error",
		};
		dispatch(
			setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
		);
		dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
		dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
		setTimeout(() => {
			dispatch(setAlertMessageSnackbarOpen(false));
		}, 5000);
	};
	const axiosInstance = axios.create({
		timeout: 30000,
	});

	const upload_images_data_db = async (formData, image_name, maxRetries = 3) => {
		let attempt = 0;

		const tryUpload = () => {

			axiosInstance.post(
				"/process_data/upload_process_store_individually",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			)
				.then(response => {
					if (response.status === 200) {

						const res = {
							image_name: image_name,
							status: 1,
							type: "sql_upload_status"
						}
						dispatch(set_image_upload_status(res))

					}
					console.log("Successful", response.data);
				})
				.catch(error => {
					attempt++;
					if (attempt < maxRetries && (error.code === 'ECONNABORTED' || (error.response && error.response.status >= 500))) {
						console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
						// setTimeout(tryUpload, Math.pow(2, attempt) * 1000);
					} else {
						console.error("Max retries reached or non-retryable error:", error);
					}
				});
		};

		tryUpload();


	};
	const buttonStyle = {
		display: "flex",
		cursor: "pointer",
		alignItems: "center",
		justifyContent: "center",
		width: "72px",
		height: "72px",
		backgroundColor: "transparent",
		borderRadius: "50%",
		border: perfectImage ? "4px solid #4CAF50" : "4px solid white",
		padding: "1px", // gap
	};

	const innerCircleStyle = {
		width: "55px",
		height: "55px",
		backgroundColor: "white",
		borderRadius: "50%",
	};


	const handleRecapture = () => {
		setShowCamera(true);
		setImageCaptured(false);
		setHasRetaken(false)
	};

	const dataURLtoBlob = (dataUrl) => {
		const parts = dataUrl.split(";base64,");
		const contentType = parts[0].split(":")[1];
		const raw = window.atob(parts[1]);
		const rawLength = raw.length;
		const uInt8Array = new Uint8Array(rawLength);

		for (let i = 0; i < rawLength; ++i) {
			uInt8Array[i] = raw.charCodeAt(i);
		}

		return new Blob([uInt8Array], { type: contentType });
	};
	const [imageDimensionsNew, setimageDimensionsNew] = useState({})
	console.log(imageCaptured, "574")
	const handleTakePhoto = () => {
		if (numberOfCameras !== 0) {
			if (camera.current) {
				const photo = camera.current.takePhoto();
				const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");
				// console.log(formattedCaptureTime, "207");
				const blob = dataURLtoBlob(photo);
				const file = new File([blob], "captured_image.jpeg", {
					type: "image/jpeg",
				});
				setImage(file);
				setCapturedTime(formattedCaptureTime);
			}
			setImageCaptured(true);
		}
	};

	const capturePhoto = React.useCallback(() => {
		const imageSrc = webcamRef.current.getScreenshot({
			width: videoConstraintsRef.current.width,
			height: videoConstraintsRef.current.height,
			quality: 1,
		});
		const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");

		const dataURLtoBlob = (dataURL) => {
			const byteString = atob(dataURL.split(',')[1]);
			const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
			const ab = new ArrayBuffer(byteString.length);
			const ia = new Uint8Array(ab);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ab], { type: mimeString });
		};

		const blob = dataURLtoBlob(imageSrc);
		console.log(imageSrc, "imageSrc")
		const file = new File([blob], "captured_image.jpeg", {
			type: "image/jpeg",
		});

		setImage(file);
		setCapturedTime(formattedCaptureTime);

		// Convert the file to an ArrayBuffer (Buffer)
		const reader = new FileReader();
		reader.onloadend = () => {
			const buffer = reader.result;
			setImageBuffer(buffer)
			console.log(buffer); // You can now use the buffer
			// Do something with the buffer if needed
		};
		reader.readAsArrayBuffer(file);
		setImageCaptured(true);
	}, [webcamRef]);
	// const capturePhoto = React.useCallback(() => {
	// 	const imageSrc = webcamRef.current.getScreenshot({
	// 		width: videoConstraintsRef.current.width,
	// 		height: videoConstraintsRef.current.height,
	// 		quality: 1,
	// 	});
	// 	const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");
	
	// 	const dataURLtoBlob = (dataURL) => {
	// 		const byteString = atob(dataURL.split(',')[1]);
	// 		const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
	// 		const ab = new ArrayBuffer(byteString.length);
	// 		const ia = new Uint8Array(ab);
	// 		for (let i = 0; i < byteString.length; i++) {
	// 			ia[i] = byteString.charCodeAt(i);
	// 		}
	// 		return new Blob([ab], { type: mimeString });
	// 	};
	
	// 	const blob = dataURLtoBlob(imageSrc);
	// 	const file = new File([blob], "captured_image.jpeg", {
	// 		type: "image/jpeg",
	// 	});
	
	// 	const zoomFactor = 1.1;
	// 	const canvas = document.createElement("canvas");
	// 	const img = new Image();
	// 	img.src = imageSrc;
	
	// 	img.onload = () => {
	// 		const ctx = canvas.getContext("2d");
	// 		const scaledWidth = img.width / zoomFactor;
	// 		const scaledHeight = img.height / zoomFactor;
	
	// 		canvas.width = scaledWidth;
	// 		canvas.height = scaledHeight;
	
	// 		const cropX = (img.width - scaledWidth) / 2;
	// 		const cropY = (img.height - scaledHeight) / 2;
	
	// 		// Draw the cropped image onto the canvas
	// 		ctx.drawImage(img, cropX, cropY, scaledWidth, scaledHeight, 0, 0, scaledWidth, scaledHeight);
	
	// 		// Convert the canvas to a blob asynchronously and handle the result
	// 		canvas.toBlob((croppedBlob) => {
	// 			if (!croppedBlob) {
	// 				console.error("Blob creation failed");
	// 				return;
	// 			}
	
	// 			const croppedFile = new File([croppedBlob], "zoomed_captured_image.jpeg", {
	// 				type: "image/jpeg",
	// 			});
	
	// 			// Set the captured image and other states
	// 			setImage(croppedFile);
	// 			setCapturedTime(formattedCaptureTime);
	
	// 			const reader = new FileReader();
	// 			reader.onloadend = () => {
	// 				const buffer = reader.result;
	// 				setImageBuffer(buffer);
	// 				console.log(buffer);
	// 			};
	// 			reader.readAsArrayBuffer(croppedFile);
	
	// 			setImageCaptured(true);
	// 		}, "image/jpeg");
	// 	};
	// }, [webcamRef]);
	
	// const handleUserMedia = () => {
	//   if (webcamRef.current) {
	//     webcamRef.current.video.current.style.zoom = '80%';
	//   }
	// };
	useEffect(() => {
		const updateOrientation = () => {
			setIsInLandscapeMode(window.screen.orientation.type);
		};

		window.addEventListener("orientationchange", updateOrientation);

		return () => {
			window.removeEventListener("orientationchange", updateOrientation);
		};
	}, [isInLandscapeMode]);

	 const handleStartCaptureClick = useCallback(() => {
		// Toggle button type state
		setBtnType(!btnType);
		console.log("start");

		// Access the video stream from the webcam reference
		const videoElement = webcamRef.current.video;
		const stream = videoElement?.srcObject;

		// Check if the stream is available before proceeding
		if (!stream) {
			console.error("Stream not available. Ensure webcam is active.");
			return;
		}

		// Start capturing the video
		setCapturing(true);

		// Reset timer and clear any existing intervals
		clearInterval(intervalRef.current);
		if(currentImageTitle.viewName === "RPM Meter Video")
			timerRef.current = 31;
			else
			timerRef.current = 61;

		// Check if the mimeType is supported by the browser
		const mimeType = isIOS() ? "video/mp4" : "video/webm";
		const options = {
			mimeType: MediaRecorder.isTypeSupported(mimeType) ? mimeType : 'video/webm', // Fallback to webm if mp4 is not supported
			videoBitsPerSecond: 5000000, // Set a high bitrate for video (5Mbps)
			audioBitsPerSecond: 256000, // Bitrate for audio
		};

		try {
			// Create MediaRecorder with the valid stream and options
			mediaRecorderRef.current = new MediaRecorder(stream, options);

			mediaRecorderRef.current.addEventListener('dataavailable', handleDataAvailable);

			// Start the recording process
			mediaRecorderRef.current.start();

			// Set up the timer for recording
			intervalRef.current = setInterval(() => {
				if (timerRef.current > 0) {
					timerRef.current -= 1;
					setCapturing(prev => !prev);  // Force re-render for timer UI
				}
			}, 1000); // Increment timer every second

		} catch (error) {
			console.error("Error starting the MediaRecorder:", error);
		}
	}, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable, btnType]);

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
	};

	// const handleStartCaptureClick =  useCallback(() => {
	// 	setBtnType(!btnType);

	// 	console.log("start")
	// 	const videoElement = webcamRef.current.video;
	// 	const stream = videoElement.srcObject;

	// 	setCapturing(true);

	// 	clearInterval(intervalRef.current);
	// 	timerRef.current = 61;

	// 	// mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
	// 	//   mimeType: "video/webm",
	// 	// });
	// 	const mimeType = isIOS() ? "video/mp4" : "video/webm"; // Use mp4 for iOS
	// 	let options = { 
	// 	  mimeType: mimeType ,
	// 	  videoBitsPerSecond: 5000000, // Set a high bitrate for video (5Mbps)
	// 	audioBitsPerSecond: 256000,
	// 	 };

	// // Check if the browser supports mp4 recording
	// // if (!MediaRecorder.isTypeSupported('video/mp4')) {
	// //   options = {
	// //      mimeType: 'video/webm' ,
	// //      videoBitsPerSecond: 2500000, // Bitrate for video
	// //      audioBitsPerSecond: 128000,  
	// //     }; // Fallback to webm for non-iOS devices
	// // }

	//    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, options);

	// 	// mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
	// 	//   mimeType: "video/mp4",
	// 	//   videoBitsPerSecond: 2500000, // Bitrate for video
	// 	//   audioBitsPerSecond: 128000,   // Bitrate for audio
	// 	// });


	// 	mediaRecorderRef.current.addEventListener(
	// 	  'dataavailable',
	// 	  handleDataAvailable
	// 	);
	// 	// Start the timer

	// 	// Start the timer after 1 second delay
	// 	intervalRef.current = setInterval(() => {
	// 	  if (timerRef.current > 0) {
	// 		timerRef.current -= 1;
	// 		setCapturing(prev => !prev);  // This forces re-render for timer UI
	// 	  }
	// 	}, 1000); // Increment timer every second


	// 	mediaRecorderRef.current.start();  // Record in smaller chunks
	//   }, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable,btnType]);
	useEffect(() => {
		const checkPermissions = () => {
			navigator.permissions
				.query({ name: "camera" })
				.then((permissionStatus) => {
					if (permissionStatus.state === "granted") {
					} else if (permissionStatus.state === "prompt") {
						// Prompt the user for camera permission
						navigator.mediaDevices
							.getUserMedia({ video: true })
							.then(() => {
								console.log("Prompting for camera permissions");
							})
							.catch((error) => {
								console.log("Error:", error);
							});
					} else {
					}
				})
				.catch((error) => console.log("Error:", error));
		};
		checkPermissions();
	}, []);
	console.log(currentImageTitle.viewName, "457");


	// const [zoomLevel, setZoomLevel] = useState("!");
	// useEffect(() => {
	// 	const checkZoomLevel = async () => {
	// 		try {
	// 			// Get the video track from the webcam
	// 			const stream = webcamRef.current?.video.srcObject;
	// 			if (stream) {
	// 				const track = stream.getVideoTracks()[0];
	// 				const capabilities = track.getCapabilities(); // To see if zoom is supported
	// 				const settings = track.getSettings(); // Get current settings

	// 				// Check if zoom is supported by the device
	// 				if (capabilities.zoom) {
	// 					setZoomLevel(settings.zoom || "Default zoom");
	// 				} else {
	// 					setZoomLevel("Zoom not supported on this device");
	// 				}
	// 			}
	// 		} catch (error) {
	// 			console.error("Error fetching zoom level: ", error);
	// 		}
	// 	};

	// 	// Call the function when the webcam stream is ready
	// 	if (webcamRef.current) {
	// 		webcamRef.current.video.addEventListener("loadedmetadata", checkZoomLevel);
	// 	}

	// 	return () => {
	// 		if (webcamRef.current) {
	// 			webcamRef.current.video.removeEventListener("loadedmetadata", checkZoomLevel);
	// 		}
	// 	};
	// }, [webcamRef]);
	const [zoomLevel, setZoomLevel] = useState(1);
	useEffect(() => {
        const applyZoom = async () => {
            try {
                const stream = webcamRef.current?.video?.srcObject;
                if (stream) {
                    const track = stream.getVideoTracks()[0];
                    const capabilities = track.getCapabilities();
                    if (capabilities.zoom) {
                        const settings = track.getSettings();
                        setZoomLevel(settings.zoom || 1);
                        await track.applyConstraints({
                            advanced: [{ zoom: 1.08 }],
                        });
                        setZoomLevel(1.00);
                    } else {
                        console.log("Zoom is not supported on this device.");
                    }
                }
            } catch (error) {
                console.error("Error applying zoom level: ", error);
            }
        };

        if (webcamRef.current) {
            webcamRef.current.video.addEventListener("loadedmetadata", applyZoom);
        }

        return () => {
            if (webcamRef.current) {
                webcamRef.current.video.removeEventListener("loadedmetadata", applyZoom);
            }
        };
    }, [webcamRef]);
	return (
		<div ref={cameraContainerRef}>
			<Dialog
				open={open}
				onClose={handleClose}
				className="full_screen_class"
				PaperProps={{
					style: {
						width: dialogWidth,
						padding: "0.5rem 0.5rem",
						paddingBottom: "0.5rem",
						borderRadius: "4px",
						// position:"absolute",
						// top:"0",
						margin: "0",
					},
				}}
			>
				<DialogContent sx={{ padding: "0.2rem 0.3rem" }}>
					<DialogTitle
						style={{
							fontSize: dialogText,
							// textAlign: "center",
							color: "black",
							padding: "0.4rem 0",
							fontWeight: "600",
						}}
					>
						Full Screen Mode ?
					</DialogTitle>
					<DialogContentText sx={{ color: "black", fontSize: "0.8rem" }}>
						Switch to full screen mode.
					</DialogContentText>
				</DialogContent>
				<DialogActions sx={{ padding: "0.4rem" }}>
					<div
						style={{
							// border: "1px solid #367588",
							// borderRadius: "30px",
							padding: "0.1rem",
						}}
					>
						<button
							onClick={handleFullscreenRequest}
							style={{
								color: "white",
								backgroundColor: "#ff0066",
								border: "none",
								padding: "0.4rem 0.8rem",
								textTransform: "capitalize",
								borderRadius: "20px",
								cursor: "pointer",
							}}
						>
							Switch
						</button>
					</div>
				</DialogActions>
			</Dialog>
			{isInLandscapeMode === "portrait-primary" ||
				isInLandscapeMode === "portrait-secondary" ? (
				<div
					style={{
						// backgroundColor: "#427eea",
						opacity: "0.8",
						height: "100svh",
						width: "100%",
						display: "flex",
						alignItems: "center",
						flexDirection: "column",
						justifyContent: "center",
					}}
				>
					<img
						src={landscape}
						alt="Landscape GIF"
						style={{
							height: "4rem",
							// animation: "tiltDown 1s ease infinite alternate",
						}}
					/>
					<h3
						style={{
							// color: "#fff",
							textAlign: "center",
							marginBottom: "0.5rem",
							wordWrap: "break-word",
						}}
					>
						PLEASE ROTATE YOUR DEVICE
					</h3>
					<h6
						style={{
							// color: "#fff",
							padding: "0 1rem",
							textAlign: "center",
							wordWrap: "break-word",
						}}
					>
						Turn on auto-rotation as picture needs to be captured in landscape
						mode.
					</h6>
				</div>
			) : showImage ? (
				<div
					style={{
						width: "100%",
						height: "100svh",
						zIndex: 100,
						position: "absolute",
						backgroundColor: "black",
						backgroundImage: image ? `url(${URL.createObjectURL(image)})` : "",
						backgroundSize: "contain",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
					}}
					onClick={() => setShowImage(!showImage)}
				/>
			) : (
				<>
				 {showInstructionPage ? <Photo_Video_Instruction setShowInstructionPage={setShowInstructionPage }/> :
				 <>
				 <Typography
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							padding: "8px 8px",
							gap: "10px",
							position: "absolute",
							width: "auto",
							height: "33px",
							left: "15px",
							top: "24px",
							background: "rgba(255, 255, 255, 0.6)",
							borderRadius: "8px",
							fontFamily: "'Montserrat', sans-serif",
							fontStyle: "normal",
							fontWeight: 500,
							fontSize: "14px",
							lineHeight: "157%",
							textAlign: "center",
							letterSpacing: "0.1px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							color: "black",
							zIndex: 100,
							"@media (max-width: 900px)and (orientation: landscape)": {
								fontSize: "12px",
							},
						}}
					>

						{currentImageTitle.viewName === "Selfie" ? `Take Selfie with the car` : currentImageTitle.viewName === `RPM Meter Video${changed}` || currentImageTitle.viewName === "Engine Video" ?`Take ${currentImageTitle.viewName} of the car`:`Take ${currentImageTitle.viewName} of the car`}

					</Typography>
					<Box
						style={{


							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							padding: "8px 8px",
							gap: "10px",
							position: "absolute",
							width: "auto",
							height: "38px",
							right: "100px",
							top: "24px",
							background: "rgba(255, 255, 255, 0.6)",
							borderRadius: "8px",
							fontFamily: "'Montserrat', sans-serif",
							fontStyle: "normal",
							fontWeight: 500,
							fontSize: "14px",
							lineHeight: "157%",
							textAlign: "center",
							letterSpacing: "0.1px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							color: "black",
							zIndex: 100,
						}}
					>
						<ImageProgressBar />
					</Box>

					{(suggestion && (!imageCaptured || !videoCaptured)) && (<Typography
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							padding: "8px 8px",
							gap: "10px",
							position: "absolute",
							width: "auto",
							height: "33px",
							left: "15px",
							bottom: "30px",
							background: "rgba(255, 255, 255, 0.6)",
							borderRadius: "8px",
							fontFamily: "'Montserrat', sans-serif",
							fontStyle: "normal",
							fontWeight: 500,
							fontSize: "13px",
							lineHeight: "157%",
							textAlign: "center",
							letterSpacing: "0.1px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							color: "black",
							zIndex: 100,
							"@media (max-width: 900px)and (orientation: landscape)": {
								fontSize: "12px",
							},
						}}
					>{suggestion}</Typography>)}

					<div>
						{!isModalVisible && (
							<div
								style={{
									position: 'absolute',
									right: '2rem',
									top: '24px',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									padding: '0.2rem 0.8rem',
									zIndex: 2000,
									background: 'rgba(255, 255, 255, 0.9)',
									borderRadius: '10px',
									boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
									backdropFilter: 'blur(10px)',
								}}
							>
								<img
									src={cameraOption}
									alt="Camera Option"
									style={{
										cursor: 'pointer',
										width: '2rem',
										height: '2rem',
										transition: 'transform 0.3s ease, filter 0.3s ease',
									}}
									onClick={openCameraOption}
									onMouseOver={(e) => {
										e.currentTarget.style.transform = 'scale(1.15)';
										e.currentTarget.style.filter = 'brightness(1.2)';
									}}
									onMouseOut={(e) => {
										e.currentTarget.style.transform = 'scale(1)';
										e.currentTarget.style.filter = 'brightness(1)';
									}}
								/>
							</div>
						)}

						<Modal footer={null} open={isModalVisible} onCancel={handleCancel}
							//  width={800}
							className="inspection-steps-modal"
							bodyStyle={{
								padding: '0',
								display: 'flex',
								flexDirection: 'column',
								height: 'auto',
								overflowY: 'auto',
								position: 'relative',
								//   maxWidth: '90vw',  // Maximum width of the modal
								width: 'auto',
							}}
							style={{
								//   position: 'fixed',
								top: '24px',
								right: '0rem',
								zIndex: 2000,

							}}
						>

							<div style={{ flex: 1, overflow: 'auto' }}>
								<InspectionSteps />

							</div>
						</Modal>
					</div>
					<div
						className="image-page"
						style={{
							display: "flex",
							flexDirection: "row",
							width: windowDimensions.width,//"100%",
							height: windowDimensions.height,//"100svh",
							display: imageCaptured || videoCaptured ? "none" : "flex"
							// position: "relative",
						}}
						ref={containerRef}
					>
						<div
							className="webcam-container"
							style={{
								width: "100vw",
								height: "100svh",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								backgroundColor: "black",
								overflow: "hidden",
								position: "relative",
							}}
						>
							<div
								style={{
									position: "absolute",
									top: "5px",
									left: "50%",
									transform: "translateX(-50%)",
									zIndex: 10,
									backgroundColor: "rgba(0, 0, 0, 0.5)",
									color: "white",
									padding: "5px 10px",
									borderRadius: "5px",
									height: "20px",
									fontSize: "0.8rem",
									display: "flex",
									alignItems: "center",
								}}
							>
								{zoomLevel !== "!" ? `Zoom: ${zoomLevel}x` : "Zoom not detected"}

							</div>
							<Webcam
								audio={true}
								muted={true}
								mirrored={false}
								ref={webcamRef}

								screenshotFormat="image/jpeg"
								screenshotQuality={1}
								videoConstraints={videoConstraintsRef.current}
								height="100%"
								width="100%"
								className="webcam"
								style={{
									position: "absolute",
									textAlign: "center",
									zIndex: 8,
									right: 0,
									objectFit: "cover",
									overflow: "hidden",
									transform: "scale(1.03)",
									transformOrigin: "center center" 
								}}
							/>
							{/* {currentImageTitle?.imageStencils && <img
								src={currentImageTitle?.imageStencils}
								alt="Car"
								style={{
									position: "absolute",
									width: "100vw",
									height: "100svh",
									objectFit: "cover",
									zIndex: 9, // Higher z-index to ensure it's above the webcam feed
								}}
							/>} */}
						</div>
						{/* {currentImageTitle?.imageStencils && <img
								src={currentImageTitle?.imageStencils}
								alt="Car"
								style={{
									position: "absolute",
									width: "100vw",
									height: "100svh",
									objectFit: "cover",
									zIndex: 9, // Higher z-index to ensure it's above the webcam feed
								}}
							/>} */}
						<div style={{
							position: 'absolute',
							right: '50%',
							top: '50%',
							transform: 'translate(50%, -50%)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							padding: '0.5rem 1rem',
							zIndex: 2000,
							color: "white",
							fontSize: "1.5rem",
							borderRadius: "50%",
						}}>
							{timerRef.current - 1 <= 5 && <VideoTimer number={timerRef.current - 1} />}
						</div>
						{!btnType && <Typography
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								padding: "8px 8px",
								gap: "10px",
								position: "absolute",
								width: "auto",
								height: "33px",
								right: "15px",
								top: "100px",
								background: "rgba(255, 255, 255, 0.6)",
								borderRadius: "8px",
								fontFamily: "'Montserrat', sans-serif",
								fontStyle: "normal",
								fontWeight: 500,
								fontSize: "14px",
								lineHeight: "157%",
								textAlign: "center",
								letterSpacing: "0.1px",
								whiteSpace: "nowrap",
								overflow: "hidden",
								color: "black",
								zIndex: 100,
								"@media (max-width: 900px)and (orientation: landscape)": {
									fontSize: "12px",
								},
							}}
						>
							{formatTime(timerRef.current - 1)}

						</Typography>}
						<div
							style={{
								position: "absolute",
								right: "1.5rem",
								height: "100svh",
								display: "flex",
								justifyContent: "flex-end",
								flexDirection: "column",
								gap: "1rem",
								top: "44px",
								zIndex: 2000,
							}}
						>
							<div
								style={{
									// position: "relative",
									// bottom: "60px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									height: "100svh"
								}}
							>
								{currentImageTitle.mode === "photo" ? <button style={buttonStyle} onClick={capturePhoto}>
									<div style={innerCircleStyle}></div>
								</button> : <div style={buttonStyle} onClick={btnType ? handleStartCaptureClick : handleStopCaptureClick}>
									<div style={{ ...innerCircleStyle, backgroundColor: btnType ? "green" : "#F44336" }}></div>
								</div>}

							</div>
						</div>
					</div>
                    
					{imageCaptured && (
						<div
							style={{
								width: "100vw",
								height: "100svh",
								overflow: "hidden",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								backgroundColor: "black",
							}}
						>
							<div
								style={{
									position: "absolute",
									top: "60%",
									// // right: "1.5rem",
									transform: "translateY(-50%)",
									display: "flex",
									flexDirection: "column",
									alignContent: "center",
									justifyContent: "center",
									gap: "6rem",

									// bottom: "20px"
								}}
							>
								{currentImageTitle.mode === "photo" ?
									<>
										<CustomToastify />
										<button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
											<img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
											<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.5rem", cursor: "pointer" }} onClick={handleRetakeClick}>Retake</p>
										</button></> :
									< > <CustomVideoToastify />
										<button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
											<img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
											<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.5rem", cursor: "pointer" }}
												onClick={handleRetakeClick}
											>Retake</p>
										</button></>
								}


							</div>

							{currentImageTitle.mode === "photo" &&
								<img
									src={URL.createObjectURL(image)}
									alt="Captured"
									style={{
										width: "100%",
										height: "100%",
										objectFit: "cover"
									}}
								/>
							}
						</div>
					)}
					{videoCaptured && (
						<div
							style={{
								width: "100vw",
								height: "100svh",
								overflow: "hidden",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								backgroundColor: "black",
							}}
						>
							<div
								style={{
									position: "absolute",
									top: "60%",
									// // right: "1.5rem",
									transform: "translateY(-50%)",
									display: "flex",
									flexDirection: "column",
									alignContent: "center",
									justifyContent: "center",
									gap: "6rem",

									// bottom: "20px"
								}}
							>
								{currentImageTitle.mode === "photo" ?
									<>
										<CustomToastify />
										<button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
											<img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
											<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.5rem", cursor: "pointer" }} onClick={handleRetakeClick}>Retake</p>
										</button></> :
									< > <CustomVideoToastify />
										<button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
											<img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
											<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.5rem", cursor: "pointer" }}
												onClick={handleRetakeForVideo}
											>Retake</p>
										</button></>
								}


							</div>

							{currentImageTitle.mode === "photo" &&
								<img
									src={URL.createObjectURL(image)}
									alt="Captured"
									style={{
										width: "100%",
										height: "100%",
										objectFit: "cover"
									}}
								/>
							}
						</div>
					)}
				 </>}
					

				</>
			)
			}

			<SnackbarAlert />
		</div >
	);
};

export default CameraModuleHybrid;
